const style = theme => ({
  container: {
    display: 'flex',
    gap: theme.spacing(2),
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      height: 'auto',
    },
  },
  mainSection: {
    flex: '1 1 50%',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '640px',
    gap: '16px',
    position: 'relative',
  },
  imageSection: {
    flex: '1 1 50%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    maxWidth: '640px',
    position: 'relative',
    '@media (max-width: 768px)': {
      flex: '1 1 auto',
      order: 1,
    },
  },
  searchBar: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    width: '20%',
  },
  content: {
    height: 'calc(100% - 110px)',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    padding: theme.spacing(2),
    backgroundColor: 'white',
    maxWidth: 600,
  },

  imageItem: {
    marginBottom: 5,
    width: 256,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '16px',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    width: 500,
    height: 450,
  },

  cardHeader: {
    marginBottom: '10px',
    display: 'inline-block',
    width: '100%',
  },
  cardTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '36px',
    float: 'left',
  },
  imageCard: {
    width: '100%',
    height: '51%',
    padding: '16px',
    backgroundColor: '#F4F6F8',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'none',
  },

  ////
  section: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'space-between',
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: '14px',
    width: '100%',
    float: 'left',
    textAlign: 'left',
    marginBottom: theme.spacing(1),
  },
  random: {
    height: '26px',
    fontWeight: 500,
    fontSize: '12px',
    color: '#00a350',
    float: 'right',
    lineHeight: '21px',
    border: '1px solid #00a350 ',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#ffffff',
      border: '1px solid #00a350 ',
    },
  },
  presets: {
    padding: 8,
  },

  preset: {
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    float: 'left',
    width: '90px',
    height: '90px',
    cursor: 'pointer',
    backgroundColor: '#F4F6F8',
    '&:hover': {
      outline: '3px solid #00a350 !important',
    },
  },
  requestButton: { backgroundColor: '#00AB55', borderRadius: 8 },
  resultImage: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  previewText: {
    position: 'absolute',
    left: 0,
    top: 0,
    marginLeft: 10,
    marginTop: 10,
  },
  media: {
    width: '100%',
    height: '100px',
  },
  aiImageIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
    marginRight: 10,
    marginTop: 10,
    color: '#00a350',
  },
  limitText: {
    textAlign: 'left',
    fontWeight: 400,
    color: '#919EAB',
    fontSize: '10px',
  },
  generatedImage: {
    borderRadius: '16px',
    width: '100%',
    maxHeight: '365px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  // New styles moved from inline styles
  flexGrowDiv: {
    flexGrow: 1,
  },
  aiIcon: {
    marginRight: 4,
  },
  limitImage: {},
  limitTitle: {
    fontWeight: 500,
    fontSize: '16px',
    textAlign: 'center',
    color: '#015FFB',
  },
  limitDescription: {
    fontWeight: 400,
    fontSize: '14px',
    textAlign: 'center',
  },
  upgradeButton: {
    width: '100%',
  },
  emptyStateCard: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyStateText: {
    color: '#919EAB',
    fontWeight: 450,
    fontSize: '12px',
  },
  inspirationContainer: {
    position: 'relative',
    minHeight: '24px',
    overflow: 'hidden',
    marginLeft: 3,
  },
  inspirationText: {
    transition: 'opacity 0.5s ease-in-out, transform 0.5s ease-in-out',
    opacity: 1,
    transform: 'translateY(0)',
  },
  inspirationTextFadeOut: {
    opacity: 0,
    transform: 'translateY(-10px)',
  },
  inspirationTextFadeIn: {
    marginTop: '1px',
    opacity: 1,
    transform: 'translateY(0)',
  },
  backgroundImage: {
    position: 'absolute',
    top: '22%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '408px',
    height: '408px',
    zIndex: -1,
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    justifyContent: 'center',
    marginTop: '4px',
    marginBottom: '4px',
  },
  headerIcon: {
    width: '32px',
    height: '32px',
    marginRight: '8px',
  },
  headerTitle: {
    fontWeight: 400,
    fontSize: '24px',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  inspirationRow: {
    display: 'flex',
    alignItems: 'center',
  },
  inspirationLabel: {
    fontWeight: 400,
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
  },
  generateButton: {
    width: '50%',
  },
  endIconContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  coinIcon: {
    marginRight: '2px',
  },
  coinText: {
    fontSize: 12,
  },
  useImageButton: {
    marginBottom: '12px',
  },
  loadingContainer: {
    borderRadius: '16px',
    width: '100%',
    maxHeight: '365px',
    backgroundColor: '#F4F6F8',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '16px',
  },
  loadingText: {
    fontSize: 12,
    fontWeight: 500,
    color: '#637381',
    textAlign: 'center',
  },
  astranautImage: {
    width: '100%',
    position: 'relative',
  },
  seePlansButton: {
    width: '50%',
    marginTop: '16px',
  },
  limitReachedDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '80%',
  },
  limitReachedContainer: {
    backgroundImage: 'url(/assets/astranaut.png)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: '360px',
    height: '100%',
    backgroundRepeat: 'round',
  },
})

export default style
